import * as consts from '../constants';
import initialState from './initialState';

export default function commonReducer(state = initialState.commonState, action) {
    switch (action.type) {
        case consts.ACTONS.SCREEN_LOCK_REQUEST:
            return Object.assign({}, state, { blocking: ++state.blocking });
        case consts.ACTONS.SCREEN_UNLOCK_REQUEST:
            return Object.assign({}, state, { blocking: --state.blocking });
        case consts.ACTONS.LOAD_CONFIGURATION_SUCCESS:
            return Object.assign({}, state, { configuration: action.configuration });

        default:
            return state;
    }
}